var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAddInputreact = function SvgAddInputreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 5",
    d: "M11.3 24v-7.8A8.037 8.037 0 0 0 8 12.72H0v-1.406h7.942A8.025 8.025 0 0 0 11.3 7.8V0h1.408v7.8a8.036 8.036 0 0 0 3.356 3.513H24v1.407h-8a8.027 8.027 0 0 0-3.294 3.48V24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8991",
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
};

export default SvgAddInputreact;